import { SubscriptionType } from 'src/app/enums/SubscriptionType';

export class Subscription {
  public constructor(init?: Partial<Subscription>) {
    Object.assign(this, init);
  }

  id: number;
  name: string;
  nameHebrew: string;
  price: number;
  lessonsCount?: number;
  description: string;
  descriptionHebrew: string;
  isOnline: boolean;
  bundleId?: number;
  camp?: any;
  subscriptionType?: SubscriptionType;
  createCampRequest?: any;
  stripePaymentLink?: string | null;
}
